// extracted by mini-css-extract-plugin
module.exports = {"cont":"BizGoodsModal_cont__2rdsv","box":"BizGoodsModal_box__hwRiT","header":"BizGoodsModal_header__QinJm","space":"BizGoodsModal_space__1pIKv"};